import { createReducer, on } from '@ngrx/store';
import { startLoading, stopLoading } from './ui.actions';

export const initialState = false;

export const loadingReducer = createReducer(
  initialState,
  on(startLoading, () => true),
  on(stopLoading, () => false)
); 